type CookieOptions = {
  expires?: string;
  maxAge?: number;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: "Strict" | "Lax" | "None";
}

export function SetCookie(name: string, value: string,  options?: CookieOptions) {
  const data      = `${name}=${value};`;
  const maxAge    = options?.maxAge  ? `Max-Age=${options.maxAge};` : "";
  const expires   = options?.expires ? `expires=${options.expires};`: "";
  const path      = options?.path    ? `path=${options.path};` : "path=/;";
  const domain    = options?.domain  ? `domain=${options.domain};` : "";
  const secure    = options?.secure  ? "Secure;" : "";
  const sameSite  = options?.sameSite? `SameSite=${options.sameSite};` : "";

  document.cookie = `${data} ${maxAge} ${expires} ${path} ${domain} ${secure} ${sameSite}`;
}

export function GetCookieValue(name: string) {
  const cookies = document.cookie.split("; ");
  const target = cookies.find(cookie =>
    cookie.startsWith(`${encodeURIComponent(name)}=`) ||
    cookie.startsWith(`${name}=`)
  );

  if (!target) {
    return undefined;
  }

  const valuePart = target?.split("=")[1];
  return decodeURIComponent(valuePart);
}

export function DeleteCookie(name: string, options?: Omit<CookieOptions, "expires" | "maxAge">) {
  // 直接削除は出来なさそうなので有効期限を使って削除
  // 有効期限を 1970-01-01 にして上書き
  const maxAge    = "Max-Age=0;";
  const path      = options?.path ? `path=${options.path};` : "path=/;";
  const domain    = options?.domain ? `domain=${options.domain};` : "";
  const secure    = options?.secure ? "Secure;" : "";
  const samesite  = options?.sameSite? `SameSite=${options.sameSite};` : "";

  // どうせすぐ消えるので値はなくていい
  document.cookie = `${name}=; ${maxAge} ${path} ${domain} ${secure} ${samesite}`;
}